import React from 'react'
import { Box, Typography, Avatar } from '@mui/material';
import { useSelector } from 'react-redux';
import '../../assets/styles/Home.css';
import { useNavigate } from 'react-router-dom'
import whiteLogoImage from '../../assets/images/logos/whiteLogo.png';

function HeaderThank() {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  // Fonction pour générer les initiales (2 lettres)
  const getInitials = (name) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map(word => word.charAt(0).toUpperCase())
      .slice(0, 2)
      .join('');
  };

  const handleLogin = () => {
    navigate('/HomePage');
  };

  const handleProfile = () => {
    // Ici vous pouvez ajouter la logique pour accéder au profil
    navigate('/profile');
  };

  return (
    <header className="headerThank" >
      <Box sx={{paddingTop:'10px'}}>
      <Box sx={{  display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',gap:'10px',cursor:'pointer'}}>
          <img src={whiteLogoImage} alt="Logo" width="50" height="50" onClick={handleLogin}/>
         <Box  sx={{lineHeight:'0.2rem',color:'#fff'}}>
          <Typography  sx={{ fontWeight: 'bold', fontSize: '1.25rem',  fontFamily: 'Achiko'}}>
             baoubab
          </Typography>
          <Typography sx={{  fontSize: '0.5rem',  marginTop: -1 }}>By bokonzi</Typography>
         </Box>


          </Box>
      </Box>
       <Box sx={{paddingTop:'20px'}}>
      
       </Box>
    </header>
  )
}

export default HeaderThank